/* unplugin-vue-components disabled */import { render } from "./ingest.vue?vue&type=template&id=37c200e5&scoped=true"
import script from "./ingest.vue?vue&type=script&setup=true&lang=js"
export * from "./ingest.vue?vue&type=script&setup=true&lang=js"

import "./ingest.vue?vue&type=style&index=0&id=37c200e5&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c200e5"],['__file',"src/pages/settings/superuser/ingest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37c200e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37c200e5', __exports__)) {
    api.reload('37c200e5', __exports__)
  }
  
  module.hot.accept("./ingest.vue?vue&type=template&id=37c200e5&scoped=true", () => {
    api.rerender('37c200e5', render)
  })

}


export default __exports__